import React from 'react';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_TEXT_INVERSE,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_TERTIARY,
} from '../colors/colors';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  gap: 12px;
`;

const ErrorTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
`;

const ErrorMessage = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${COLOR_TEXT_TERTIARY};
`;

const RetryButton = styled.button`
  margin-top: 8px;
  padding: 10px 24px;
  background: ${COLOR_TEXT_PRIMARY};
  color: ${COLOR_TEXT_INVERSE};
  border: none;
  border-radius: ${RADIUS.SM};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
`;

export class YouErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[You Platform] Error in ${this.props.remoteName || 'unknown'}:`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <ErrorContainer>
            <ErrorTitle>Algo deu errado</ErrorTitle>
            <ErrorMessage>
              {this.props.errorMessage || 'Não foi possível carregar este conteúdo.'}
            </ErrorMessage>
            <RetryButton onClick={this.handleRetry}>Tentar novamente</RetryButton>
          </ErrorContainer>
        )
      );
    }

    return this.props.children;
  }
}
